import { render, staticRenderFns } from "./DDSReportsByProductsCard.vue?vue&type=template&id=33229e25&scoped=true"
import script from "./DDSReportsByProductsCard.vue?vue&type=script&lang=js"
export * from "./DDSReportsByProductsCard.vue?vue&type=script&lang=js"
import style0 from "./DDSReportsByProductsCard.vue?vue&type=style&index=0&id=33229e25&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33229e25",
  null
  
)

export default component.exports